@if (isBetCardRedesigned) {
    <ms-my-bets-summary [stakeLabel]="stakeLabel" [returnLabel]="returnLabel" [stakeValue]="stakeValue" [returnValue]="possibleWinningsValue" />
} @else {
    <div class="mybets-betslip-summary mybets-row clearfix">
        @if (myBetsListContext.isPrintView) {
            <div class="mybets-betslip-summary_cell mybets-betslip-summary_date">
                <div class="label">{{ dateLabel }}</div>
            </div>
        }

        <div class="mybets-betslip-summary_cell mybets-betslip-summary_stake">
            <div class="label stack-label">
                {{ stakeLabel }}

                @if (isTurnoverTax) {
                    <button ds-button-icon size="small" variant="flat" kind="tertiary" (click)="winsInfoClick()">
                        <vn-icon name="theme-info" size="12" />
                    </button>
                }
            </div>
        </div>
        <div class="mybets-betslip-summary_cell mybets-betslip-summary_totalodds">
            <div class="label">{{ totalOddsLabel }}</div>
        </div>
        <div class="mybets-betslip-summary_cell mybets-betslip-summary_possible-winnings" [ngClass]="{ 'is-won': isWon }">
            <div class="label" [innerHTML]="possibleWinningsLabel"></div>
        </div>
        @if (myBetsListContext.isPrintView) {
            <div class="mybets-betslip-summary_cell mybets-betslip-summary_date">
                <div class="value font-big">
                    @if (!isEpcotEnabled) {
                        {{ dateValue | msMyBetsEventDateTimePipe }}
                    } @else {
                        {{ dateValue | msMyBetsEventDatePipe }}
                    }
                </div>
            </div>
        }

        <div class="mybets-betslip-summary_cell mybets-betslip-summary_stake">
            <div class="value font-big">
                <div class="mybets-betslip-summary_stake-value highlight">{{ stakeValue }}</div>
                @if (shouldShowRiskFreeInfoIcon && !myBetsListContext.isPrintView) {
                    <div class="mybets-betslip-summary_stake-value-info">
                        <button
                            class="stake-info-icon"
                            ds-button-icon
                            variant="flat"
                            kind="tertiary"
                            [size]="isEpcotEnabled ? 'small' : 'medium'"
                            (click)="toggleDetails()">
                            <vn-icon name="theme-info" />
                        </button>
                    </div>
                }
            </div>
        </div>
        <div class="mybets-betslip-summary_cell mybets-betslip-summary_totalodds">
            <div class="value font-big highlight">
                @if (oddsAreBoosted) {
                    <span class="old-odds">{{ totalOddsValue }}</span> <span class="boosted-odds">{{ boostedOdds }}</span>
                } @else if (isPriceBoost) {
                    <span class="was-price was-price-betslip"> {{ priceBoostOriginalOdds }}</span>
                    <ms-priceboost-count-signpost [isLargeSignPost]="true" [count]="totalOddsValue" />
                } @else {
                    <span
                        [ngClass]="{
                            'original-odds': enableSGPRepricedOdds && (betslip.isOGPRepricePending || !!betslip.totalOGPRepricedOdds),
                        }">
                        {{ totalOddsValue }}
                    </span>
                    @if (enableSGPRepricedOdds && (betslip.isOGPRepricePending || !!betslip.totalOGPRepricedOdds)) {
                        <span class="repriced-odds">
                            {{
                                betslip.isOGPRepricePending
                                    ? this.sitecoreMyBets.myBets.PendingOdds
                                    : (this.betslip.totalOGPRepricedOdds | msMyBetsOddsPipe)
                            }}
                        </span>
                    }
                }
            </div>
            @if (isBOGVisible) {
                <ms-help-box-badge class="best-odds" [ngClass]="{ bogNotPaidOut: isBOGNotPaidOut }" [boxType]="'bestoddsguarantee'" />
            }
        </div>
        <div class="mybets-betslip-summary_cell mybets-betslip-summary_possible-winnings" [ngClass]="{ 'is-won': isWon }">
            <div class="value font-big" [ngClass]="{ won: isWon }">
                @if (accaBoostUsed) {
                    <span class="old-winnings">{{ possibleWinningsValue }}</span> <span class="new-winnings">{{ boostedWinningsValue }}</span>
                } @else {
                    <div class="mybets-betslip-summary_possible-winnings-value">{{ possibleWinningsValue }}</div>
                }
                @if (shouldShowOddsBoostInfoIcon && !myBetsListContext.isPrintView) {
                    <div class="mybets-betslip-summary_possible-winnings-info">
                        <button
                            class="stake-info-icon"
                            ds-button-icon
                            variant="flat"
                            kind="tertiary"
                            [size]="isEpcotEnabled ? 'small' : 'medium'"
                            (click)="toggleDetails()">
                            <vn-icon name="theme-info" />
                        </button>
                    </div>
                }
            </div>
            @if (isBOGPaidOut && hasFixedPriceWinnings) {
                <div class="bog-value">{{ fixedPriceWinnings }}</div>
            }
        </div>
        @if (isTurnoverTax) {
            <ms-my-bets-taxation-info [(isVisible)]="isInfoVisible" />
        }
    </div>
}
